import {CodeReviewIcon, CommentDiscussionIcon} from '@primer/octicons-react'
import {Blankslate} from '@primer/react/experimental'

export function CommentsEmptyState({reviewCommentsMode}: {reviewCommentsMode: boolean}) {
  return (
    <div className="d-flex flex-column position-relative width-full height-full flex-justify-center">
      {reviewCommentsMode ? (
        <Blankslate>
          <Blankslate.Visual>
            <CodeReviewIcon size="medium" />
          </Blankslate.Visual>
          <Blankslate.Heading>No review comments yet</Blankslate.Heading>
        </Blankslate>
      ) : (
        <Blankslate>
          <Blankslate.Visual>
            <CommentDiscussionIcon size="medium" />
          </Blankslate.Visual>
          <Blankslate.Heading>No comments yet</Blankslate.Heading>
          <Blankslate.Description>Add a comment to start the conversation.</Blankslate.Description>
        </Blankslate>
      )}
    </div>
  )
}
